import { ColDef, ICellRendererParams } from '@ag-grid-community/core'
import AggregatorsCellRenderer from './aggregatorsCellRenderer'
import ActionCellRenderer from './actionCellRenderer'

export const getColumns = ({
  aggregators,
  isEditor,
}: {
  isEditor: boolean
  aggregators: any[]
}) =>
  [
    { headerName: 'Store Name', field: 'storeName', maxWidth: 250 },
    {
      headerName: 'Aggregators',
      field: 'aggregators',
      minWidth: 300,
      // set auto height
      wrapText: true,
      autoHeight: true,
      valueFormatter: (params) => {
        return params.value || ''
      },
      // Custom renderer
      cellRenderer: (params: ICellRendererParams) => (
        <AggregatorsCellRenderer
          isEditor={isEditor}
          options={aggregators}
          params={params}
        />
      ),
    },
    {
      hide: !isEditor,
      headerName: 'Action',
      field: 'save',
      maxWidth: 250,
      cellRenderer: (params: ICellRendererParams) => (
        <ActionCellRenderer isEditor={isEditor} params={params} />
      ),
    },
  ] as ColDef[]
